import { client, writeClient } from './sanity.client';

// Fetch options for instant data refresh (no cache)
const fetchOptions = { next: { revalidate: 0 } };

export async function getWebsiteTextContent(locale: string) {
  const field = (enField: string, arField: string) => (locale === 'ar' ? arField : enField);

  const query = `*[_type == "websiteTextContent"][0]{
    "videoSectionTitle": ${field('videoSectionTitle.en', 'videoSectionTitle.ar')},
    "videoSectionDesc": ${field('videoSectionDesc.en', 'videoSectionDesc.ar')},
    "clientsSectionSmallTitle": ${field(
      'clientsSectionSmallTitle.en',
      'clientsSectionSmallTitle.ar'
    )},
    "clientsSectionTitle": ${field('clientsSectionTitle.en', 'clientsSectionTitle.ar')},
    "workSectionSmallTitle": ${field('workSectionSmallTitle.en', 'workSectionSmallTitle.ar')},
    "workSectionTitle": ${field('workSectionTitle.en', 'workSectionTitle.ar')},
    "workSectionDesc": ${field('workSectionDesc.en', 'workSectionDesc.ar')},
    "servicesSectionSmallTitle": ${field(
      'servicesSectionSmallTitle.en',
      'servicesSectionSmallTitle.ar'
    )},
    "servicesSectionTitle": ${field('servicesSectionTitle.en', 'servicesSectionTitle.ar')},
    "servicesSectionDesc": ${field('servicesSectionDesc.en', 'servicesSectionDesc.ar')},
    "workStatsSectionTitle": ${field('workStatsSectionTitle.en', 'workStatsSectionTitle.ar')},
    "trendsSectionSmallTitle": ${field('trendsSectionSmallTitle.en', 'trendsSectionSmallTitle.ar')},
    "trendsSectionTitle": ${field('trendsSectionTitle.en', 'trendsSectionTitle.ar')},
    "contactUsSectionSmallTitle": ${field(
      'contactUsSectionSmallTitle.en',
      'contactUsSectionSmallTitle.ar'
    )},
    "contactUsSectionTitle": ${field('contactUsSectionTitle.en', 'contactUsSectionTitle.ar')},
    "contactUsSectionDesc": ${field('contactUsSectionDesc.en', 'contactUsSectionDesc.ar')},
    contactUsSectionNumber,
    contactUsSectionEmail,
    "contactUsSectionAddress": ${field('contactUsSectionAddress.en', 'contactUsSectionAddress.ar')},
    "contactUsSectionFormTitle": ${field(
      'contactUsSectionFormTitle.en',
      'contactUsSectionFormTitle.ar'
    )},
    "contactUsSectionFormDesc": ${field(
      'contactUsSectionFormDesc.en',
      'contactUsSectionFormDesc.ar'
    )}
  }`;
  return client.fetch(query, {}, fetchOptions);
}

export async function getLogoGalleries(locale: string) {
  const altField = locale === 'ar' ? 'altAr' : 'alt';
  const query = `*[_type == "logoGallery"]{
    _id,
    title,
    logos[]{
      image,
      "alt": ${altField}
    }
  }`;
  return client.fetch(query, {}, fetchOptions);
}

export async function getAccordionItems(locale: string) {
  const query = `*[_type == "accordionItem"]{
    _id,
    "title": title.${locale},
    "description": description.${locale},
    subservices[]{
      en,
      ar
    },
    image,
    "alt": image.alt_${locale}
  }`;
  return client.fetch(query, {}, fetchOptions);
}

export async function getTrendsItems(locale: string) {
  const query = `*[_type == "trendsItem"]{
    _id,
    image,
    logoImage,
    "imageAlt": image.alt_${locale},
    "logoAlt": logoImage.alt_${locale},
    "title": title.${locale},
    "description": description.${locale}
  }`;
  return client.fetch(query, {}, fetchOptions);
}
export async function getWorkItems(locale: string) {
  const query = `*[_type == "workItem"]{
    _id,
    image,
    "alt": image.alt_${locale},
    year,
    "title": title.${locale},
    "description": description.${locale},
    logo,
    "logoAlt": logo.alt_${locale}
  }`;
  return client.fetch(query, {}, fetchOptions);
}

export async function getMainVideo() {
  const query = `*[_type == "videos"] | order(_updatedAt desc)[0]{
    _id,
    "videoUrl": mainComponentVideoLaptop.asset->url,
    "videoUrlMobile": mainComponentVideoMobile.asset->url
  }`;
  return client.fetch(query, {}, fetchOptions);
}

export async function getCEOVideo() {
  const query = `*[_type == "videos"][0]{
    _id,
    "videoUrl": ceoVideo.asset->url
  }`;
  return client.fetch(query, {}, fetchOptions);
}

export async function getWorkStats(locale: string) {
  const query = `*[_type == "workStats"]{
    _id,
    "title": title.${locale},
    "description": description.${locale},
    stats
  }`;
  return client.fetch(query, {}, fetchOptions);
}

export async function getTermsAndConditions(locale: string) {
  const query = `*[_type == "termsAndConditions"][0]{
    "title": title.${locale},
    "doc1": doc1.${locale},
    "doc2": doc2.${locale},
    "doc3": doc3.${locale},
    "doc4": doc4.${locale},
    lastUpdated,
    version
  }`;
  return client.fetch(query, {}, fetchOptions);
}

export type ContactMessageInput = {
  name: string;
  number: string;
  email: string;
  subject: string;
  message: string;
};

export async function createContactMessage(data: ContactMessageInput) {
  return writeClient.create({
    _type: 'contactMessage',
    ...data,
    read: false,
  });
}
